<template>
  <div class="mainContent grid">
    <div class="page-block u-16">
      <div class="grid between u-16">
        <div class="title-page">
          Интеграция с ВТБ
        </div>
      </div>
    </div>
    <div class="page-block cross-center u-16">
      <div class="block">
        <el-steps :active="active" finish-status="success" align-center style="margin-bottom: 12px;">
          <el-step title="Выбор терминала"></el-step>
          <el-step title="Логин\пароль"></el-step>
          <el-step title="SMS-подтверждение"></el-step>
          <el-step title="Выбор организации"></el-step>
        </el-steps>
        <el-row>
          <el-col
            :span="24"
            v-show="active === 0"
          >
            <div class="grid-content">
              <h1 class="title has-text-centered">Выберите терминал ВТБ</h1>
              <b-select
                placeholder="Терминал не установлен"
                v-model="selectedTerminal">
                <option
                  v-for="terminal in vtbTerminals"
                  :key="terminal.name"
                  :value="terminal.name"
                >{{terminal.human_name}}</option>
              </b-select>
            </div>
            <el-row style="margin-top: 12px;">
              <el-button @click="onGetStatusTerminal" :disabled="!selectedTerminal">
                Статус терминала
              </el-button>
              <el-button @click="onStopTerminal" :disabled="!selectedTerminal">
                Остановить терминал
              </el-button>
            </el-row>
            <el-row style="margin-top: 12px;">
              <el-button
                @click="prev"
                :disabled="active <= 0"
              >Назад</el-button>
              <el-button @click="next" :disabled="!selectedTerminal">Далее</el-button>
            </el-row>
          </el-col>
          <el-col
            :span="24"
            v-show="active === 1"
          >
            <div class="grid-content">
              <h1 class="title has-text-centered">Логин\пароль терминала</h1>
              <div class="input-w300">
                <b-field label="Введите логин от терминала">
                  <b-input v-model="terminalLogin"></b-input>
                </b-field>
              </div>
              <div class="input-w300">
                <b-field label="Введите пароль от терминала">
                  <b-input v-model="terminalPassword" type="password"></b-input>
                </b-field>
              </div>
            </div>
            <el-row>
              <el-button
                style="margin-top: 12px;"
                @click="prev"
                :disabled="active <= 0"
              >Назад</el-button>
              <el-button style="margin-top: 12px;" @click="next" :disabled="!terminalLogin || !terminalPassword">Далее</el-button>
            </el-row>
          </el-col>
          <el-col
            :span="24"
            v-show="active === 2"
          >
            <div class="grid-content">
              <h1 class="title has-text-centered">SMS-код</h1>
              <div class="input-w300">
                <b-field label="Введите sms-код">
                  <b-input
                    v-model="smsCode"
                    type="tel"
                    maxlength="6"
                    @keydown.native="onKeyDown($event)"
                  ></b-input>
                </b-field>
              </div>
              <el-row style="margin-top: 12px">
                <el-button plain @click="sendCred">Запросить код повторно</el-button>
                <el-button plain @click="sendSms" :disabled="!smsCode || smsCode.length !== 6"
                >Проверить код</el-button>
              </el-row>
            </div>
            <el-row>
              <el-button
                style="margin-top: 12px;"
                @click="prev"
                :disabled="active <= 0"
              >Назад</el-button>
              <el-button style="margin-top: 12px;" @click="next" :disabled="!smsCode || smsCode.length !== 6">Далее</el-button>
            </el-row>
          </el-col>
          <el-col
            :span="24"
            v-show="active === 3"
          >
            <div class="grid-content">
              <h1 class="title has-text-centered">Организация</h1>
              <b-select placeholder="Выберите организацию" v-model="selectedOrganization">
                <option
                  v-for="organization in organizationList"
                  :key="organization.tin"
                  :value="organization.client"
                >{{organization.name}}</option>
              </b-select>
              <el-row style="margin-top: 12px">
                <el-button plain @click="setOrganization" :disabled="!selectedOrganization">Сохранить</el-button>
              </el-row>
              <el-row>
                <el-button
                  style="margin-top: 12px;"
                  @click="prev"
                  :disabled="active <= 0"
                >Назад</el-button>
                <el-button style="margin-top: 12px;" @click="resetForm">Завершить</el-button>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: "VtbAuth",
  data() {
    return {
      axiosInstance: null,
      active: 0,
      selectedTerminal: null,
      selectedOrganization: null,
      terminalLogin: null,
      terminalPassword: null,
      smsCode: '',
      organizationList: null,
      proxy: ''
    }
  },
  methods: {
    next() {
      if (this.active++ > 3) this.active = 0
    },
    prev() {
      if (this.active-- < 0) this.active = 3
    },
    sendCred() {
      const h = this.$createElement

      this.axiosInstance.post('/send-cred', {
        terminalKey: this.selectedTerminal,
        login: this.terminalLogin,
        password: this.terminalPassword,
        proxy: this.proxy
      }).then(({data: {result}}) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: teal' }, `SMS-код отправлен на ${result.phoneMask}`),
          type: 'success'
        })
      }).catch((err) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: warning' }, `Произошла ошибка ${err.response.data.description}`),
          type: 'warning'
        })
      })
    },
    sendSms() {
      const h = this.$createElement

      this.axiosInstance.post('/sms-code', {
        terminalKey: this.selectedTerminal,
        smsCode: this.smsCode,
        proxy: this.proxy
      }).then(({data: {result}}) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: teal' }, `Клиент активен на ${result.activeClient}`),
          type: 'success'
        })
        this.organizationList = result.organizations
        this.selectedOrganization = result.activeClient
        this.active += 1
      }).catch((err) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: warning' }, `Произошла ошибка ${err.response.data.description}`),
          type: 'warning'
        })
      })
    },
    setOrganization() {
      const h = this.$createElement

      this.axiosInstance.post('/set-organization', {
        terminalKey: this.selectedTerminal,
        activeClient: this.selectedOrganization,
        proxy: this.proxy
      }).then(({data: {description}}) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: teal' }, `${description}`),
          type: 'success'
        })
        this.resetForm()
      }).catch((err) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: warning' }, `Произошла ошибка ${err.response.data.description}`),
          type: 'warning'
        })
      })
    },
    onGetStatusTerminal() {
      const h = this.$createElement

      this.axiosInstance.get(`/get-terminal-status/${this.selectedTerminal}`).then(({data: {result: {lastTime}}}) => {
        const lastTimeUpdate = new Date(lastTime).getTime()
        const currentTime = new Date().getTime()

        if (Math.round((currentTime - lastTimeUpdate) / 60000 ) < 15) {
          this.$notify({
            title: 'Уведомление',
            message: h('i', { style: 'color: teal' }, `Терминал активен`),
            type: 'success'
          })
        } else {
          this.$notify({
            title: 'Уведомление',
            message: h('i', { style: 'color: warning' }, `Необходимо повторно авторизовать терминал`),
            type: 'error'
          })
        }

      }).catch((err) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: warning' }, `Произошла ошибка ${err.response.data.description}`),
          type: 'warning'
        })
      })
    },
    onStopTerminal() {
      const h = this.$createElement

      this.axiosInstance.post(`/stop-terminal/${this.selectedTerminal}`).then(({data: {description}}) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: teal' }, `${description}`),
          type: 'success'
        })
      }).catch((err) => {
        this.$notify({
          title: 'Уведомление',
          message: h('i', { style: 'color: warning' }, `Произошла ошибка ${err.response.data.description}`),
          type: 'warning'
        })
      })
    },
    onKeyDown(evt) {
      const code = evt.key

      if (
        code === 'Backspace' ||
        code === 'Delete' ||
        code === 'ArrowLeft' ||
        code === 'ArrowRight'
      ) {
        return false
      } else {
        const regex = /[^0-9]/gi
        if (regex.test(code)) {
          evt.preventDefault()
        }
        if (this.smsCode.length > 6) {
          evt.preventDefault()
        }
      }
    },
    resetForm() {
      this.active = 0
      this.selectedTerminal = null
      this.selectedOrganization = null
      this.terminalLogin = null
      this.terminalPassword = null
      this.smsCode = ''
      this.organizationList = null
      this.proxy = ''
    }
  },
  watch: {
    active(newValue, oldValue) {
      if (newValue === 2) {
        this.sendCred()
      }
    },
      selectedTerminal(n, o) {
        const idx = this.vtbTerminals.findIndex(t => t.name === n)
        if (idx !== -1) {
            this.proxy = this.vtbTerminals[idx].proxy
        } else {
            this.proxy = ""
        }
      }
  },
  computed: {
    ...mapGetters([
      "terminalList",
      "processingList"
    ]),
    vtbTerminals() {
      if (!this.vtbProcessing) {
        return []
      } else {
        return this.terminalList.filter(terminal => terminal.processing_id === this.vtbProcessing.id)
      }
    },
    vtbProcessing() {
      if (this.processingList.length < 1) {
        return null
      } else {
        return this.processingList.filter(processing => processing.name.toLowerCase().includes('vtb'))[0]
      }
    }
  },
  beforeMount() {
    this.$store.dispatch("getMerchant");
    this.$store.dispatch("getTerminal");
    this.$store.dispatch("getProcessing");

    this.axiosInstance = axios.create({
      baseURL: '/api/bovtb',
      headers: {
        'Authorization-Token': localStorage.getItem('Authorization-Token')
      }
    })
  }
}
</script>
